import { Injectable, Injector } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { from, map, Observable, of, switchMap } from 'rxjs';
import { AuthService } from '../portal/auth.service';
import { Store } from '@ngxs/store';
import { AuthState } from '../portal/auth.state';
import { AppFeaturesState } from '../portal/app-feature.state';
import { AppFeaturesService } from '../portal/app-features.service';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
	constructor(
		private authService: AuthService,
		private store: Store,
		private appFeaturesService: AppFeaturesService,
		private appFeaturesState: AppFeaturesState,
		private injector: Injector
	) {}

	intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
		const authState = this.store.selectSnapshot(AuthState.state);
		const token = authState.token || this.authService.getToken();
		const langState = this.store.selectSnapshot(AppFeaturesState.state);
		const lang$ = langState.lang ? of(langState.lang) : from(this.appFeaturesService.getCurrentLang());

		return lang$.pipe(
			map((lang) => {
				// eslint-disable-next-line @typescript-eslint/no-explicit-any
				const header: any = {};

				const appInfo = this.appFeaturesState.appInfo;
				const deviceInfo = this.appFeaturesState.deviceInfo;

				const appData = {
					platform: deviceInfo?.platform,
					device: deviceInfo?.model,
					os_version: deviceInfo?.osVersion,
					app_version: appInfo?.version || this.appFeaturesState.appVersion,
					app_build: appInfo?.build || 1,
				};

				header['X-App-Data'] = JSON.stringify(appData);

				header['device'] = this.appFeaturesState.deviceType;
				header[
					'X-User-Agent'
				] = `DanceBUG/${this.appFeaturesState.appVersion} (${this.appFeaturesState.deviceType}; Device and App data unavailable)`;

				if (appInfo && deviceInfo) {
					header[
						'X-User-Agent'
					] = `${appInfo.name}/${appInfo.version}(build ${appInfo.build}) (${deviceInfo.model}; ${deviceInfo.operatingSystem} ${deviceInfo.osVersion}; webViewVersion: ${deviceInfo.webViewVersion})`;
				}

				if (token) {
					header.Token = token;
				}

				if (typeof lang === 'string' && lang) {
					header['Accept-Language'] = lang;
				}

				request = request.clone({
					setHeaders: header,
				});

				return request;
			}),
			switchMap((request) => next.handle(request))
		);

	}
}
